module.exports = __webpack_public_path__ + "static/media/pic_winie_06.71cb8722.png";